module.exports = require("core-js/modules/es6.array.iterator");